import React from 'react';

const IconCatalogos = (props) => (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.92188 8H20.9219M4.92188 8V18C4.92188 18.5304 5.13259 19.0391 5.50766 19.4142C5.88273 19.7893 6.39144 20 6.92188 20H18.9219C19.4523 20 19.961 19.7893 20.3361 19.4142C20.7112 19.0391 20.9219 18.5304 20.9219 18V8M4.92188 8L8.92188 4H16.9219L20.9219 8M8.92188 12H12.9219" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


);

export default IconCatalogos;